import * as React from 'react';
import { cloneEntity, Entity, Row } from 'gossamer-unified';

export const useCloneEntity = <T extends Row>(entity: Entity<T>, changes?: (entity: Entity<T>) => void) => {
  return React.useMemo(() => {
    const localEntity = entity.isCloned ? entity : cloneEntity(entity);
    if (changes) {
      changes(localEntity);
    }
    return localEntity;
  }, []);
};
